// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FallbackScoreContent from "./partner_score_locales/FallbackScoreContent.bs.js";
import * as Hindi_CompletionScoreContent from "./partner_score_locales/Hindi_CompletionScoreContent.bs.js";
import * as Tamil_CompletionScoreContent from "./partner_score_locales/Tamil_CompletionScoreContent.bs.js";
import * as Telugu_CompletionScoreContent from "./partner_score_locales/Telugu_CompletionScoreContent.bs.js";
import * as English_CompletionScoreContent from "./partner_score_locales/English_CompletionScoreContent.bs.js";
import * as Hindi_CancellationScoreContent from "./partner_score_locales/Hindi_CancellationScoreContent.bs.js";
import * as Kannada_CompletionScoreContent from "./partner_score_locales/Kannada_CompletionScoreContent.bs.js";
import * as Marathi_CompletionScoreContent from "./partner_score_locales/Marathi_CompletionScoreContent.bs.js";
import * as Tamil_CancellationScoreContent from "./partner_score_locales/Tamil_CancellationScoreContent.bs.js";
import * as Telugu_CancellationScoreContent from "./partner_score_locales/Telugu_CancellationScoreContent.bs.js";
import * as English_CancellationScoreContent from "./partner_score_locales/English_CancellationScoreContent.bs.js";
import * as Kannada_CancellationScoreContent from "./partner_score_locales/Kannada_CancellationScoreContent.bs.js";
import * as Marathi_CancellationScoreContent from "./partner_score_locales/Marathi_CancellationScoreContent.bs.js";

function getContentModule(language, performance_score, vehicle_category, geo_region) {
  switch (language) {
    case /* English */0 :
        return {
                content_v1: English_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: English_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Hindi */1 :
        return {
                content_v1: Hindi_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: Hindi_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Kannada */2 :
        return {
                content_v1: Kannada_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: Kannada_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Tamil */3 :
        return {
                content_v1: Tamil_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: Tamil_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Telugu */4 :
        return {
                content_v1: Telugu_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: Telugu_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Marathi */5 :
        return {
                content_v1: Marathi_CompletionScoreContent.getContent(vehicle_category, geo_region),
                content_v2: Marathi_CancellationScoreContent.getContent(performance_score.action_details.action_text, vehicle_category, geo_region)
              };
    case /* Malayalam */6 :
    case /* Bangla */7 :
        return {
                content_v1: FallbackScoreContent.getContentV1(undefined),
                content_v2: FallbackScoreContent.getContentV2(undefined)
              };
    
  }
}

export {
  getContentModule ,
  
}
/* No side effect */
